import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    previousButton: {
        minWidth: rem(94),

        ":disabled": {
            backgroundColor: theme.colors.gray[1],
            borderColor: theme.colors.gray[3],
            cursor: "not-allowed",
        },
    },
    nextButton: {
        backgroundColor: theme.colors.violet[7],
        color: "white",
        minWidth: rem(66),

        ":disabled": {
            cursor: "not-allowed",
        },

        ":hover": {
            backgroundColor: theme.colors.violet[7],
            filter: "brightness(1.1)",
        },
    },
}))
